import { render, staticRenderFns } from "./stepsInk.vue?vue&type=template&id=18eda609&scoped=true&"
import script from "./stepsInk.vue?vue&type=script&lang=js&"
export * from "./stepsInk.vue?vue&type=script&lang=js&"
import style0 from "./stepsInk.vue?vue&type=style&index=0&id=18eda609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eda609",
  null
  
)

export default component.exports